import React, {useEffect} from 'react';
import './PersonalDataForm.css'
import '../error.css'
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {FaArrowLeft, FaTimes} from "react-icons/fa";
import {addEmployeeFilesRequest, getEmployeeRequest, removeEmployeeFileRequest} from "../redux/actions/employeeActions";
import {toast} from "react-toastify";
import {apiCall} from "../redux/utils/api";

const AdditionalDataForm = ({contract, setCurrentStep, previousStep, submitButtonText }) => {
    const dispatch = useDispatch();
    const employee = useSelector(state => state.employee.employee); // Redux State für den aktuellen Mitarbeiter
    const { handleSubmit, reset } = useForm({
        defaultValues: employee // Setzt die Standardwerte des Formulars auf die aktuellen Mitarbeiterdaten
    });

    useEffect(() => {
        if (!employee.ID) {
            dispatch(getEmployeeRequest({contractID: contract.ID}));
        }
    }, [dispatch, employee, contract.ID]);

    useEffect(() => {
        reset(employee);
    }, [employee, reset]);

    const handleFileChange = async (event) => {
        const files = event.target.files;
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]);
        }
        formData.append('employeeID', employee.ID);

        try {
            const data = await apiCall(`${process.env.REACT_APP_API_URL}/employee-api/uploadEmployeeFiles`, 'POST', formData, {timeoutMs: 120000});
            if (data.error) {
                toast(data.error, { type: 'error' });
            } else {
                if (data.msg) {
                    toast(data.msg, { type: 'success' });
                }
                dispatch(addEmployeeFilesRequest(
                    {employeeID: employee.ID, newFileIDs: data.newFileIDs}
                ));
            }
        } catch (error) {
            console.error('Fehler beim Hochladen der Datei:', error);
            toast(error.message || 'Fehler beim Hochladen der Datei', { type: 'error' });
        }
    };

    const removeFile = (index, event) => {
        const fileToRemove = employee.EmployeeFiles[index];
        dispatch(removeEmployeeFileRequest({
            employeeID: employee.ID, fileID: fileToRemove.ID}));
    };

    const onSubmit = data => {
        setCurrentStep();
    };

    return (
        <>
            <div className="row">
                <div className="col-12" style={{textAlign: "center", marginBottom: "3.5vh"}}>
                    <h2>Bereitstellung von Dokumenten</h2>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="form-container">
                <div>
                    {(employee.EmployeeFiles || []).map((file, index) => (
                        <div key={index}>
                            {file.File.Name}
                            <span role="button" onClick={() => removeFile(index)} tabIndex="0"
                                  style={{color: "red"}}><FaTimes/></span>
                        </div>
                    ))}
                </div>
                <hr/>
                <div className="mb-3 form-field">
                    <label className="form-label">Zusätzliche Dateien (optional): </label>
                    <input type="file" onChange={handleFileChange} multiple/>
                </div>
                <div className="form-navigation-buttons">
                    {previousStep && contract.Status !== "RECTORATE" && (
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={previousStep}
                        >
                            <FaArrowLeft/> Zurück
                        </button>
                    )}
                    <button type="submit" className="btn btn-primary">{submitButtonText}</button>
                </div>
            </form>
        </>
    );
};

export default AdditionalDataForm;
